import { forwardRef, type ButtonHTMLAttributes } from 'react';

import { cn } from '@/utils/cn';

import { Icon, type IconName } from './Icon';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  iconSize?: number;
  variant?: 'default' | 'bordered' | 'danger';
  size?: 'sm' | 'md';
  label: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, iconSize = 15, variant = 'default', size = 'md', label, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={cn(
        'ds-icon-btn',
        size === 'sm' && 'ds-icon-btn-sm',
        variant === 'bordered' && 'bordered',
        variant === 'danger' && 'danger',
        className,
      )}
      {...rest}
    >
      <Icon name={icon} size={iconSize} />
    </button>
  );
});
